import handleResponse from "helpers/handleAPIResponse";
import qs from "query-string";
const baseUrl = process.env.REACT_APP_ADMIN_BASE_URL;

export const fetchVoiceoverUploads = params => {
  const search = qs.stringify(params, { skipNull: true });
  return fetch(`${baseUrl}/Voiceovers/Uploads?${search}`, {
    method: "GET",
    headers: {
      authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },
  })
    .then(handleResponse)
    .catch(err => {
      throw new Error(err?.message ?? "Get voiceover uploads failed");
    });
};

export const fetchVoiceoverUploadsById = ({ uploadId, params }) => {
  const search = qs.stringify(params, { skipNull: true });
  return fetch(`${baseUrl}/Voiceovers/Uploads/${uploadId}?${search}`, {
    method: "GET",
    headers: {
      authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },
  })
    .then(handleResponse)
    .catch(err => {
      throw new Error(err?.message ?? "Get voiceover uploads failed");
    });
};
export const fetchDownloadVoiceoverUploadsCsv = uploadId => {
  return fetch(`${baseUrl}/Voiceovers/Uploads/${uploadId}/csv`, {
    method: "GET",
    headers: {
      Accept: "text/csv",
      authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },
  })
    .then(res => res.text())
    .catch(err => {
      throw new Error(err?.message ?? "Download voiceover upload csv failed");
    });
};
export const fetchPostVoiceoverByCsv = data => {
  return fetch(`${baseUrl}/Voiceovers/Uploads/Generates`, {
    method: "POST",
    body: data,
    headers: {
      authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },
  })
    .then(handleResponse)
    .catch(err => {
      throw new Error(err?.message ?? "post voiceover uploads failed");
    });
};
export const fetchPostVoiceoverUploads = data => {
  return fetch(`${baseUrl}/Voiceovers/Uploads`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      authorization: `Bearer ${localStorage.getItem("access_token")}`,
      "content-type": "application/json",
    },
  })
    .then(handleResponse)
    .catch(err => {
      throw new Error(err?.message ?? "post voiceover uploads failed");
    });
};
export const fetchPostVoiceoverBulk = data => {
  return fetch(`${baseUrl}/Voiceovers/Uploads/Bulk`, {
    method: "POST",
    body: data,
    headers: {
      authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },
  })
    .then(handleResponse)
    .catch(err => {
      throw new Error(err?.message ?? "post voiceover uploads failed");
    });
};
